import { i as get4, n as setFlag, r as sendInvoice, t as setInvoice } from "./setInvoice.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/internal/payment/hooks/useGet4.ts
const get4QueryKey = ({ path }) => [{
	url: "/api/mdm/internal/api/internal/requests/:id/payment",
	params: path
}];
function get4QueryOptions({ path }, config = {}) {
	const queryKey = get4QueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await get4({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Данные оплаты по заявке
* {@link /api/mdm/internal/api/internal/requests/:id/payment}
*/
function useGet4({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? get4QueryKey(resolvedParams);
	const queryResult = useQuery({
		...get4QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/internal/payment/hooks/useSendInvoice.ts
const sendInvoiceMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:id/payment/invoice/send" }];
function sendInvoiceMutationOptions(config = {}) {
	const mutationKey = sendInvoiceMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await sendInvoice({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Отправить счёт заявителю (пометить на выгрузку оператору)
* {@link /api/mdm/internal/api/internal/requests/:id/payment/invoice/send}
*/
function useSendInvoice(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? sendInvoiceMutationKey();
	const baseOptions = sendInvoiceMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/payment/hooks/useSetFlag.ts
const setFlagMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:id/payment/flag" }];
function setFlagMutationOptions(config = {}) {
	const mutationKey = setFlagMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await setFlag({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Установить признак оплаты (Аппарат НГ, статус «Согласование НГ»)
* {@link /api/mdm/internal/api/internal/requests/:id/payment/flag}
*/
function useSetFlag(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? setFlagMutationKey();
	const baseOptions = setFlagMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/internal/payment/hooks/useSetInvoice.ts
const setInvoiceMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:id/payment/invoice" }];
function setInvoiceMutationOptions(config = {}) {
	const mutationKey = setInvoiceMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await setInvoice({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Выставить/изменить счёт (Аппарат НГ, PAID, до отправки)
* {@link /api/mdm/internal/api/internal/requests/:id/payment/invoice}
*/
function useSetInvoice(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? setInvoiceMutationKey();
	const baseOptions = setInvoiceMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { setFlagMutationOptions as a, sendInvoiceMutationOptions as c, get4QueryOptions as d, useGet4 as f, setFlagMutationKey as i, useSendInvoice as l, setInvoiceMutationOptions as n, useSetFlag as o, useSetInvoice as r, sendInvoiceMutationKey as s, setInvoiceMutationKey as t, get4QueryKey as u };

//# sourceMappingURL=useSetInvoice.js.map